import React, { useId, useState } from "react";
import { FaInfoCircle } from "react-icons/fa";
import { useT } from "../../contexts/TranslationContext";

const GLOSSARY_ITEMS = [
  { termKey: "projectDetails.customerEconomyHelpStackedTerm", bodyKey: "projectDetails.customerEconomyHelpStacked" },
  { termKey: "projectDetails.reportedHours", bodyKey: "projectDetails.customerEconomyHelpReportedHours" },
  { termKey: "projectDetails.costInclVat", bodyKey: "projectDetails.customerEconomyHelpCost" },
  { termKey: "projectDetails.materialsAndSubsInclVat", bodyKey: "projectDetails.customerEconomyHelpMaterials" },
  { termKey: "projectDetails.expectedCostsColumnInclVat", bodyKey: "projectDetails.customerEconomyHelpExpected" },
  { termKey: "projectDetails.estimatedHours", bodyKey: "projectDetails.customerEconomyHelpEstimatedHours" },
  { termKey: "projectDetails.estimatedCostInclVat", bodyKey: "projectDetails.customerEconomyHelpCalculatedActual" },
];

/** Toggleable glossary for the Customer economy table columns and stacked totals. */
export default function CustomerEconomyHelp() {
  const { t } = useT();
  const [open, setOpen] = useState(false);
  const panelId = useId();

  return (
    <div>
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className={`inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-sm font-medium transition-colors ${
          open
            ? "text-amber-700 bg-amber-50"
            : "text-gray-500 hover:text-amber-700 hover:bg-amber-50"
        }`}
        aria-expanded={open}
        aria-controls={panelId}
      >
        <FaInfoCircle className="w-4 h-4 shrink-0" aria-hidden />
        {t("projectDetails.customerEconomyHelpToggle")}
      </button>
      {open && (
        <div
          id={panelId}
          className="mt-2 p-3 rounded-lg bg-amber-50 border border-amber-100 text-sm text-gray-700"
        >
          <p>{t("projectDetails.customerEconomyHelpIntro")}</p>
          <dl className="mt-3 space-y-2">
            {GLOSSARY_ITEMS.map(({ termKey, bodyKey }) => (
              <div key={termKey}>
                <dt className="font-medium text-gray-800">{t(termKey)}</dt>
                <dd className="mt-0.5">{t(bodyKey)}</dd>
              </div>
            ))}
          </dl>
        </div>
      )}
    </div>
  );
}
